module.exports = __webpack_public_path__ + "static/media/app-settings.abb7d385.PNG";